import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MultilineChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"multiline_chart"}/>
}
